export enum NotificationTypes {
  TaskReminder = 'task_reminder',
  DailyReflection = 'daily_reflection',
  WeeklyReflection = 'weekly_reflection',
}
